<script setup lang="ts">
import MenuButton from './MenuButton.vue';

/** Minimal page header: the menu button opens the navigation drawer. */
defineProps<{ title?: string }>();
</script>

<template>
  <header class="bar">
    <MenuButton />
    <slot />
  </header>
</template>

<style scoped>
.bar {
  position: sticky;
  top: 0;
  z-index: 30;
  display: flex;
  align-items: center;
  gap: 10px;
  height: auto;
  /* pages are flex columns: the header keeps its height */
  flex: none;
  /* same top and side inset as «Мои холсты» */
  padding: 16px clamp(16px, 2.6vw, 44px) 0;
}
</style>
